const MESSAGE = `
                learnlea
            learnlearnlearn
          learnlearnlearnlear
          learn          lear
        learn
        learn
        learn
        learn
          learn          lear
          learnlearnlearnlear
            learnlearnlearn
                learnlea

   ___ ___  _   _ _ __ ___  ___ _ __ __ _
  / __/ _ \\| | | | '__/ __|/ _ \\ '__/ _\` |
 | (_| (_) | |_| | |  \\__ \\  __/ | | (_| |
  \\___\\___/ \\__,_|_|  |___/\\___|_|  \\__,_|

     🎓  Passionate about education?
     💙  Come work at Coursera!
     🚀  https://careers.coursera.com
`;

export const notifyConsole = () => {
  const isCsr = typeof window !== 'undefined';
  const shouldLog =
    isCsr &&
    window.console &&
    // eslint-disable-next-line no-console
    typeof console.log === 'function' &&
    // eslint-disable-next-line no-restricted-syntax
    window.location.hostname !== 'mock.dev-coursera.org';

  if (!shouldLog) {
    return;
  }

  // eslint-disable-next-line no-console
  console.log(MESSAGE);
};
